// Module
var code = "<span ng-if=\"slots && slots.length > 0\"> ({{ slots.length - (slots | filter:{user:null}).length }} / {{ slots.length }}) </span> ";
// Exports
module.exports = code;